import React from 'react';
import { Button } from '@mui/material';

import { getLoggedInUser, hasSubscriptionManagerPermission } from '../../selectors/users';
import { useAppWithLogInDataSelector } from '../hooks';

export function ManagePaymentButton() {
  const loggedInUser = useAppWithLogInDataSelector(getLoggedInUser);
  const isSubscriptionManager = useAppWithLogInDataSelector(hasSubscriptionManagerPermission);

  if (!loggedInUser || !isSubscriptionManager) return null;

  let stripeCustomerPortalUrl: string;
  switch (process.env.APP_ENV) {
    case 'production':
      stripeCustomerPortalUrl = `https://billing.stripe.com/p/login/aEU4ihgqAeju22IdQQ?prefilled_email=${loggedInUser.email}`;
      break;
    case 'release-candidate':
      stripeCustomerPortalUrl = `https://billing.stripe.com/p/login/test_7sYeVf4TLehn1ByduV8N200?prefilled_email=${loggedInUser.email}`;
      break;
    case 'develop':
      stripeCustomerPortalUrl = `https://billing.stripe.com/p/login/test_28E9AV1xH1Hmc0dgUSew800?prefilled_email=${loggedInUser.email}`;
      break;
    case 'localhost':
      stripeCustomerPortalUrl = `https://billing.stripe.com/p/login/test_7sY6oHdA7d4G5UO9mccEw00?prefilled_email=${loggedInUser.email}`;
      break;
    default:
      throw new Error(`Unknown APP_ENV: ${process.env.APP_ENV}`);
  }

  return (
    <Button
      variant="contained"
      sx={{ color: 'white', width: '100%', mt: 2 }}
      onClick={() => void window.open(stripeCustomerPortalUrl, '_blank')}
    >
      Manage Payment
    </Button>
  );
}
